/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faPrint } from '@fortawesome/pro-duotone-svg-icons';
import { faArrowRotateLeft, faFileAlt } from '@fortawesome/pro-solid-svg-icons';

import Table from '../../../../../common/components/Table';

function EditHistory({
  enrollment = {},
  id,
  style,
  className,
}) {
  const [data, setData] = useState([]);
  useEffect(() => {

    if (enrollment && enrollment.edit_history) {
      let splitEdits = enrollment.edit_history.reduce((acc, e = {}) => {
        const { fields_diff = [], update_user = {} } = e;
        const { first_name, last_name, email } = update_user;
        
        let fieldsEdited = fields_diff.map((diff = {}) => {
          const { field, old_value, new_value } = diff;
          return {
            field,
            old_value,
            new_value,
            updated_by_name: `${first_name} ${last_name}`,
            updated_by_email: `${email}`,
          };
        });
        return [
          ...acc,
          ...fieldsEdited,
        ];
      }, []);
      setData(splitEdits);
    }      
  }, [enrollment]);


  const tableSchema = {
    cols: [
      {
        header: 'Item',
        field: 'field',
        formatter: (e) => (<div className="text-capitalize">{e.replaceAll('_', ' ')}</div>),
      },
      {
        header: 'Old value',
        field: 'old_value',
      },
      {
        header: 'New value',
        field: 'new_value',
      },
      {
        header: 'Edited by',
        field: 'updated_by_name',
        formatter: (e) => (<div className="text-capitalize">{e}</div>),
      },
    ],
  };

  return (
    <div className="d-flex w-100">
      <Table
        schema={tableSchema}
        data={data}
        className="table table-striped"
      />
    </div>
  );
}
export default EditHistory;
